export default __webpack_public_path__ + "static/frenchtech-5ba06fe71fb75b7918e981b5b3db391c.png";